export default __webpack_public_path__ + "static/media/pending.42437b85.svg";